<template>
    <h1 id="navigation-title" class="fixed-top d-flex align-items-center ml-9 mt-3">
        <strong>
            <slot></slot>
        </strong>
    </h1>
</template>

<script>
    export default {

        data: function () {
            return {
                //
            }
        },

        mounted: function () {

            if ( $('#introduction').length ) {
                var inview = new Waypoint.Inview ({

                    element: $( '#introduction' ),
                    enter: function ( direction ) {
                        $( '#navigation-title' ).removeClass( 'hidden' );
                    },
                    exited: function ( direction ) {
                        $( '#navigation-title' ).addClass( 'hidden' );
                    }
                });
            }
        },
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #navigation-title {
        height: 2.5rem;
        right: auto;
        z-index: $zindex-navbar;
        font-size: 1.8rem;
        white-space: nowrap;
        transition: opacity 1s;

        &:not(.hidden) strong:after {
            content: '';
            margin-left: .25rem;
            border-right: 0.1rem solid rgba( 0, 0, 0, 1 );
            animation: PulseAttention 1.5s linear forwards infinite;

            @keyframes PulseAttention {
                50% {
                    border-color: rgba( 0, 0, 0, 0 );
                }
            }
        }

        &.hidden {
            opacity: 0;
            transition: opacity .5s;
        }
    }
    @media (max-width: 600px) {
        #navigation-title {
            font-size: 1.2rem;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/NavigationTitle.vue